import { render } from "./CategoryView.vue?vue&type=template&id=12f4ad4f&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=12f4ad4f&scoped=true&lang=scss"

import exportComponent from "/var/www/project/coridor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f4ad4f"]])

export default __exports__